<template>
  <!-- Preloader -->
  <div class="preloader">
    <div class="cssload-speeding-wheel"></div>
  </div>
</template>

<script>
  export default {
    name: "loading",
    data(){
      return {

      }
    },
    created(){
      this.$emit("isLoading",false);
    },
    methods:{

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Loading.vue